export default __webpack_public_path__ + "static/media/Monoid-Regular.ca94925d.woff2";